import * as React from 'react';

export const UpSelectedArrow = () => (
    <svg width={10} height={6} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="m1 5 4-4 4 4" stroke="#44338A" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
